import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { urlLocations } from "routes/urlLocations";
import Header from './Header/Header';
import HeaderNew from "@/layouts/AuthorizeLayouts/navigation-header/Header";

const AuthorizeLayout = ({children}) => {
    const navigate = useNavigate();

    useEffect(() => {
        const storage = localStorage?.getItem("storageTyp");
        const jwt = window[storage]?.getItem('jwt');

        !jwt && navigate(urlLocations.login);
    }, [navigate]);

    return (
        <>
            {/*<Header/>*/}
            <HeaderNew/>
            <div>
                {children}
            </div>
        </>
    )
};

export default AuthorizeLayout;

